import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  capturePci,
  sendOtp,
  validateOtp,
  verifyPCIToken,
  verifyToken,
} from "../../services/services";

export const verifyEmailToken = createAsyncThunk(
  "creditCard/tokenVerification",
  async ({ tokenparam, orderparam }) => {
    const response = await verifyToken(tokenparam, orderparam);
    if (response.status) {
      throw new Error(response.response.data.message); // Explicitly throw the error
    }
    return response;
  }
);

export const verifyCCToken = createAsyncThunk(
  "creditCard/pciTokenVerification",
  async ({ tokenparam, orderparam, uniqueid }) => {
    const response = await verifyPCIToken(tokenparam, orderparam, uniqueid);
    // if (response.status) {
    //   throw new Error(response.response.data.message); // Explicitly throw the error
    // }
    return response;
  }
);

export const sendOtpToUser = createAsyncThunk(
  "creditCard/sendOtpToUser",
  async ({ orderId }) => {
    const response = await sendOtp(orderId);
    if (response.status) {
      throw new Error(response.response.data.message); // Explicitly throw the error
    }
    return response;
  }
);

export const checkOtpvallidity = createAsyncThunk(
  "creditCard/checkOtpvallidity",
  async ({ orderId, otp }) => {
    const response = await validateOtp(orderId, otp);
    // if (response.status) {
    //   throw new Error(response.response.data.error.message); // Explicitly throw the error
    // }
    return response?.response?.data?.error?.message
      ? response.response.data.error.message
      : response;
  }
);

export const capturePciVault = createAsyncThunk(
  "creditCard/capturePciVault",
  async ({ token, orderId }) => {
    const response = await capturePci(token, orderId);
    if (response.status) {
      throw new Error(response.response.data.message); // Explicitly throw the error
    }
    return response;
  }
);

const initialState = {
  submit_url: null,
  submit_secret: null,
  unique_id: null,
  send_otp: null,
  valid_otp: null,
  pci_captured: null,
  pciVaultResonse: null,
  loading: true,
  error: null,
  otp_error: null,
};

const creditCardSlice = createSlice({
  name: "creditCard",
  initialState,
  reducers: {
    resetPciVault: (state) => {
      state.pciVaultResonse = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(verifyEmailToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyEmailToken.fulfilled, (state, action) => {
        state.phone_number = action.payload.phone_number;
        state.loading = false;
      })
      .addCase(verifyEmailToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Credit Card form capture failed";
      })
      .addCase(verifyCCToken.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyCCToken.fulfilled, (state, action) => {
        state.pciVaultResonse = action.payload;
        state.loading = false;
      })
      .addCase(verifyCCToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(sendOtpToUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendOtpToUser.fulfilled, (state, action) => {
        state.send_otp = action.payload;
        state.loading = false;
      })
      .addCase(sendOtpToUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        state.otp_error = action.error;
      })
      .addCase(checkOtpvallidity.pending, (state) => {
        state.loading = true;
      })
      .addCase(checkOtpvallidity.fulfilled, (state, action) => {
        state.valid_otp = action.payload;
        state.loading = false;
      })
      .addCase(checkOtpvallidity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(capturePciVault.pending, (state) => {
        state.loading = true;
      })
      .addCase(capturePciVault.fulfilled, (state, action) => {
        state.pci_captured = action.payload;
        state.submit_url = action.payload.url;
        state.submit_secret = action.payload.secret;
        state.loading = false;
      })
      .addCase(capturePciVault.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetPciVault } = creditCardSlice.actions;

export default creditCardSlice.reducer;
